import { render } from "./VendorListCustom.vue?vue&type=template&id=769da070&scoped=true"
import script from "./VendorListCustom.vue?vue&type=script&lang=js"
export * from "./VendorListCustom.vue?vue&type=script&lang=js"

import "./VendorListCustom.vue?vue&type=style&index=0&id=769da070&scoped=true&lang=css"
import "./VendorListCustom.vue?vue&type=style&index=1&id=769da070&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769da070"]])

export default __exports__